<!-- <div class="row mb-2">
    <div class="col-md-6">
        <div> <input type="search" (ngModelChange)="applyFilter($event)" [(ngModel)]="searchText" class="form-control"
                placeholder="Search by city" style="width: 70%"> </div>
    </div>

    <div class="col-md-6 m-0 text-end">
      <button (click)="exportToExcel()" style="margin:0px 5px !important" class="btn-shadow  d-inline-flex align-items-center btn btn-success"><i class="fa fa-file-excel-o" aria-hidden="true"></i>
         Export Current Excel  </button>
         <button  class="btn-shadow d-inline-flex align-items-center btn btn-success"><i class="fa fa-file-excel-o" aria-hidden="true"></i>
          Export All Excel </button>
    </div>
</div> -->
<div class="row mb-2">
  <div class="col-md-2">
    <select [(ngModel)]="searchBy" class="form-control">
      <option value="">Select Search By</option>
      <option value="firstName">Name</option>
      <option value="homeStopLocation">Home Stop Location</option>
      <option value="phoneNumber">Mobile Number</option>
      <option value="city">City</option>
      <option value="vehicleType">Vehicle Type</option>
      <!-- <option value="vehicleNumber">Vehicle Number</option> -->
    </select>
  </div>
  <div class="col-md-2">
    <input
      type="search"
      [(ngModel)]="searchText"
      class="form-control mb-2"
      placeholder="Search Text"
    />
  </div>
  <div class="col-md-2">
    <button
      (click)="search()"
      class="btn btn-primary btn-block"
      [disabled]="searchBy == ''"
    >
      Search <i class="fa fa-search"></i>
    </button>
  </div>
  <div class="col-md-6 m-0 text-end">
    <button
      (click)="exportToExcel()"
      style="margin: 0px 5px !important"
      class="btn-shadow d-inline-flex align-items-center btn btn-success"
    >
      <i class="fa fa-file-excel-o" aria-hidden="true"></i> Export Current Excel
    </button>
    <div class="dropdown d-inline-flex align-items-center">
      <a
        class="btn-shadow dropdown-toggle btn btn-success"
        type="button"
        data-bs-toggle="dropdown"
      >
        <i class="fa fa-file-excel-o" aria-hidden="true"></i> Export All Excel
      </a>
      <ul class="dropdown-menu m-0 p-0">
        <li>
          <button
            class="dropdown-item"
            type="button"
            (click)="getAllDrivers(totalItems_Pending, 0)"
          >
            Pending Drivers
          </button>
        </li>
        <li>
          <button
            class="dropdown-item"
            type="button"
            (click)="getAllDrivers(totalItems_InProcess, 1)"
          >
            In-process Drivers
          </button>
        </li>
        <li>
          <button
            class="dropdown-item"
            type="button"
            (click)="getAllDrivers(totalItems_Completed, 2)"
          >
            Approved Drivers
          </button>
        </li>
        <li>
          <button
            class="dropdown-item"
            type="button"
            (click)="getAllDrivers(totalItems_Rejected, 3)"
          >
            Rejected Drivers
          </button>
        </li>
      </ul>
    </div>
  </div>

  <div class="main-card mb-3 card">
    <div class="card-header font-weight-B fs-1r d-flex justify-content-between">
      All Driver Partner Requests
    </div>

    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <button
          class="nav-link active"
          id="nav-home-tab"
          data-bs-toggle="tab"
          data-bs-target="#pending"
          type="button"
          role="tab"
          aria-controls="pending"
          aria-selected="true"
       
        >
          <i class="fa fa-clock-o" aria-hidden="true"></i> Pending Drivers
          <input
            class="text-center text-primary border border-primary rounded"
            style="width: 40px"
            *ngIf="totalItems_Pending"
            disabled
            [ngModel]="totalItems_Pending"
          />
        </button>
        <button
          class="nav-link"
          id="nav-profile-tab"
          data-bs-toggle="tab"
          data-bs-target="#in-process"
          type="button"
          role="tab"
          aria-controls="in-process"
          aria-selected="false"
         
        >
          <i class="fa fa-refresh" aria-hidden="true"></i> In-Process Drivers
          <input
            class="text-center text-primary border border-primary rounded"
            style="width: 40px"
            *ngIf="totalItems_InProcess"
            disabled
            [ngModel]="totalItems_InProcess"
          />
        </button>
        <button
          class="nav-link"
          id="nav-profile-tab"
          data-bs-toggle="tab"
          data-bs-target="#Completed"
          type="button"
          role="tab"
          aria-controls="Completed"
          aria-selected="false"
        
        >
          <i class="fa fa-check-circle-o" aria-hidden="true"></i> Approved
          Drivers
          <input
            class="text-center text-primary border border-primary rounded"
            style="width: 40px"
            *ngIf="totalItems_Completed"
            disabled
            [ngModel]="totalItems_Completed"
          />
        </button>
        <button
          class="nav-link"
          id="nav-contact-tab"
          data-bs-toggle="tab"
          data-bs-target="#Rejected"
          type="button"
          role="tab"
          aria-controls="Rejected"
          aria-selected="false"
        >
          <i class="fa fa-times-circle-o" aria-hidden="true"></i> Rejected
          Drivers
          <input
            class="text-center text-primary border border-primary rounded"
            style="width: 30px"
            *ngIf="totalItems_Rejected"
            disabled
            [ngModel]="totalItems_Rejected"
          />
        </button>
      </div>
    </nav>

    <div class="tab-content" id="nav-tabContent">
      <div
        class="tab-pane fade show active"
        id="pending"
        role="tabpanel"
        aria-labelledby="pending-tab"
      >
        <div class="table-responsive">
          <table
            class="align-middle mb-0 table table-borderless table-striped table-hover"
            id="excel-table"
          >
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Mobile</th>
                <th>City</th>
                <th>Home Stop</th>
                <th>Vehicle Type</th>
                <th>CreatedOn</th>
                <th class="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="
                  let data of allDriverPartner_PendingRequests
                    | paginate
                      : {
                          itemsPerPage: itemsPerPage,
                          currentPage: page_Pending,
                          totalItems: totalItems_Pending
                        }
                "
              >
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">{{ data._id }}</div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">
                          {{ data.firstName }} {{ data.lastName }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">{{ data.phoneNumber }}</div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">{{ data.city }}</div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">
                          {{ data.homeStopLocation }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">
                          {{ data.vehicleType }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">
                          {{
                            data.createdOnTS * 1000
                              | date : "dd MMM yyyy hh:mm a" : "en-IN"
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>

                <td class="text-end">
                  <div class="dropdown">
                    <button
                      class="btn btn-info dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Action
                    </button>
                    <ul
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li>
                        <a
                          class="dropdown-item"
                          (click)="viewDetails(content1, data)"
                          >View Details <i class="fa fa-eye"></i
                        ></a>
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          (click)="changeStatus(content2, data)"
                          >Change Status <i class="fa fa-edit"></i
                        ></a>
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          (click)="editDetails(content3, data)"
                          >Edit <i class="fa fa-edit"></i
                        ></a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
            <div
              *ngIf="allDriverPartner_PendingRequests?.length == 0"
              class="text-center mt-5 mb-5"
            >
              <span class="text-danger">Data Not found</span>
            </div>
          </table>
          <!-- <pagination-controls
            class="my-pagination"
            (pageChange)="gty_Pending((page_Pending = $event))"
          ></pagination-controls> -->

          <ngb-pagination 
          (pageChange)="gty_Pending(page_Pending = $event)" 
          [collectionSize]="totalItems_Pending" 
          [(page)]="page_Pending" 
          [pageSize]="itemsPerPage" 
          [maxSize]="3" 
          [rotate]="true" 
          [boundaryLinks]="false">
      </ngb-pagination> 
        </div>
      </div>

      <div
        class="tab-pane fade"
        id="in-process"
        role="tabpanel"
        aria-labelledby="in-process"
      >
        <div class="table-responsive">
          <table
            class="align-middle mb-0 table table-borderless table-striped table-hover"
            id="excel-table"
          >
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Mobile</th>
                <th>City</th>
                <th>Home Stop</th>
                <th>Vehicle Type</th>
                <th>CreatedOn</th>
                <th class="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="
                  let data of allDriverPartner_InProcessRequests
                    | paginate
                      : {
                          itemsPerPage: itemsPerPage,
                          currentPage: page_InProcess,
                          totalItems: totalItems_InProcess
                        }
                "
              >
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">{{ data._id }}</div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">
                          {{ data.firstName }} {{ data.lastName }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">{{ data.phoneNumber }}</div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">{{ data.city }}</div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">
                          {{ data.homeStopLocation }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">
                          {{ data.vehicleType }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">
                          {{
                            data.createdOnTS * 1000
                              | date : "dd MMM yyyy hh:mm a" : "en-IN"
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="text-end">
                  <div class="dropdown">
                    <button
                      class="btn btn-info dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Action
                    </button>
                    <ul
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li>
                        <a
                          class="dropdown-item"
                          (click)="viewDetails(content1, data)"
                          >View Details <i class="fa fa-eye"></i
                        ></a>
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          (click)="changeStatus(content2, data)"
                          >Change Status <i class="fa fa-edit"></i
                        ></a>
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          (click)="editDetails(content3, data)"
                          >Edit <i class="fa fa-edit"></i
                        ></a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
            <div
              *ngIf="allDriverPartner_InProcessRequests?.length == 0"
              class="text-center mt-5 mb-5"
            >
              <span class="text-danger">Data Not found</span>
            </div>
          </table>
          <!-- <pagination-controls
            (pageChange)="gty_InProcess((page_InProcess = $event))"
          ></pagination-controls> -->
          <ngb-pagination 
          (pageChange)="gty_InProcess(page_InProcess = $event)" 
          [collectionSize]="totalItems_InProcess" 
          [(page)]="page_InProcess" 
          [pageSize]="itemsPerPage" 
          [maxSize]="3" 
          [rotate]="true" 
          [boundaryLinks]="false">
      </ngb-pagination> 
        </div>
      </div>

      <div
        class="tab-pane fade"
        id="Completed"
        role="tabpanel"
        aria-labelledby="Completed-tab"
      >
        <div class="table-responsive">
          <table
            class="align-middle mb-0 table table-borderless table-striped table-hover"
            id="excel-table"
          >
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Mobile</th>
                <th>City</th>
                <th>Home Stop</th>
                <th>Vehicle Type</th>
                <th>CreatedOn</th>
                <th>ApprovedOn</th>
                <th class="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="
                  let data of allDriverPartner_CompletedRequests
                    | paginate
                      : {
                          itemsPerPage: itemsPerPage,
                          currentPage: page_Completed,
                          totalItems: totalItems_Completed
                        }
                "
              >
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">{{ data._id }}</div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">
                          {{ data.firstName }} {{ data.lastName }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">{{ data.phoneNumber }}</div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">{{ data.city }}</div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">
                          {{ data.homeStopLocation }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">
                          {{ data.vehicleType }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">
                          {{
                            data.createdOnTS * 1000
                              | date : "dd MMM yyyy hh:mm a" : "en-IN"
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">
                          {{
                            data.updatedOnTS * 1000
                              | date : "dd MMM yyyy hh:mm a" : "en-IN"
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="text-end">
                  <div class="dropdown">
                    <button
                      class="btn btn-info dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Action
                    </button>
                    <ul
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li>
                        <a
                          class="dropdown-item"
                          (click)="viewDetails(content1, data)"
                          >View Details <i class="fa fa-eye"></i
                        ></a>
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          (click)="changeStatus(content2, data)"
                          >Change Status <i class="fa fa-edit"></i
                        ></a>
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          (click)="editDetails(content3, data)"
                          >Edit <i class="fa fa-edit"></i
                        ></a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
            <div
              *ngIf="allDriverPartner_CompletedRequests?.length == 0"
              class="text-center mt-5 mb-5"
            >
              <span class="text-danger">Data Not found</span>
            </div>
          </table>
          <!-- <pagination-controls
            class="my-pagination"
            (pageChange)="gty_Completed((page_Completed = $event))"
          ></pagination-controls> -->
          <ngb-pagination 
          (pageChange)="gty_Completed(page_Completed = $event)" 
          [collectionSize]="totalItems_Completed" 
          [(page)]="page_Completed" 
          [pageSize]="itemsPerPage" 
          [maxSize]="3" 
          [rotate]="true" 
          [boundaryLinks]="false">
      </ngb-pagination> 
        </div>
      </div>

       <div
        class="tab-pane fade"
        id="Rejected"
        role="tabpanel"
        aria-labelledby="Rejected-tab"
      >
        <div class="table-responsive">
          <table
            class="align-middle mb-0 table table-borderless table-striped table-hover"
            id="excel-table"
          >
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Mobile</th>
                <th>City</th>
                <th>Home Stop</th>
                <th>Created On</th>
                <th>RejectReason</th>
                <th class="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="
                  let data of allDriverPartner_RejectedRequests
                    | paginate
                      : {
                          itemsPerPage: itemsPerPage,
                          currentPage: page_Rejected,
                          totalItems: totalItems_Rejected
                        }
                "
              >
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">{{ data._id }}</div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">
                          {{ data.firstName }} {{ data.lastName }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">{{ data.phoneNumber }}</div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">{{ data.city }}</div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">
                          {{ data.homeStopLocation }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">
                          {{
                            data.createdOnTS * 1000
                              | date : "dd MMM yyyy hh:mm a" : "en-IN"
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">
                          {{ data.rejectReason }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="text-end">
                  <div class="dropdown">
                    <button
                      class="btn btn-info dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Action
                    </button>
                    <ul
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li>
                        <a
                          class="dropdown-item"
                          (click)="viewDetails(content1, data)"
                          >View Details <i class="fa fa-eye"></i
                        ></a>
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          (click)="changeStatus(content2, data)"
                          >Change Status <i class="fa fa-edit"></i
                        ></a>
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          (click)="editDetails(content3, data)"
                          >Edit <i class="fa fa-edit"></i
                        ></a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
            <div
              *ngIf="allDriverPartner_RejectedRequests?.length == 0"
              class="text-center mt-5 mb-5"
            >
              <span class="text-danger">Data Not found</span>
            </div>
          </table>
          <!-- <pagination-controls
            class="my-pagination"
            (pageChange)="gty_Rejected((page_Rejected = $event))"
          ></pagination-controls> -->
          <ngb-pagination 
          (pageChange)="gty_Rejected(page_Rejected = $event)" 
          [collectionSize]="totalItems_Rejected" 
          [(page)]="page_Rejected" 
          [pageSize]="itemsPerPage" 
          [maxSize]="3" 
          [rotate]="true" 
          [boundaryLinks]="false">
      </ngb-pagination> 
        </div>
      </div>  
    </div>
  </div>

  <!-- edit model -->
  <div class="card-body modal-lg">
    
  <ng-template #content3 let-c="close" let-d="dismiss">
      <div class="modal-header">
        <h4 class="modal-title">
          <i class="fa fa-eye"></i> Update Information
        </h4>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="d('Cross click')"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-5">
              <label for="">ID : </label>
              <input
                type="text"
                [ngModel]="_id"
                [disabled]="true"
                [disabled]="true"
                class="form-control"
              />
            </div>
            <div class="col-md-5">
              <label for="">Name : </label>
              <input
                type="text"
                [ngModel]="firstName + ' ' + lastName"
                disabled
                class="form-control"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-5">
              <label for="">Email : </label>
              <input
                type="text"
                [ngModel]="emailId"
                [disabled]="true"
                class="form-control"
              />
            </div>
            <div class="col-md-5">
              <label for="">Mobile : </label>
              <input
                type="text"
                [ngModel]="phoneNumber"
              
                class="form-control"
              />
            </div>
          </div>
  <!-- [disabled]="true" -->
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-5">
              <label for="">City : </label>
              <input type="text" [(ngModel)]="city" class="form-control" />
            </div>
            <div class="col-md-5">
              <label for="">Home Stop : </label>
              <input
                type="text"
                [(ngModel)]="homeStopLocation"
                (onAddressChange)="getHomeStopData($event)"
                ngx-google-places-autocomplete
                class="form-control"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-5">
              <label for="">Vehicle Number : </label>
              <input
                type="text"
                [(ngModel)]="vehicleNumber"
                class="form-control"
              />
            </div>
            <div class="col-md-5">
              <label for="">Vehicle Type : </label>
              <select class="form-control" [(ngModel)]="vehicleType">
                <option value="">Select Vehicle Type</option>
                <option
                  value="{{ data.type }}"
                  *ngFor="let data of allVehiclesList"
                >
                  {{ data.type }}
                </option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-5">
              <label for="">Update Driver Active Status :</label>
              <select
                name=""
                id=""
                [(ngModel)]="isDeleted"
                class="form-control"
              >
                <option value="">Update Driver Active Status</option>
                <option [ngValue]="0">Active</option>
                <option [ngValue]="1">Inactive</option>
              </select>
            </div>
            <div class="col-md-5">
              <label for="">Banner Pasted : </label>
              <select class="form-control" [(ngModel)]="isBannerPasted">
                <option value="">Update Banner Status</option>
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
            </div>
            <div class="col-md-2"></div>
          </div>
          <hr class="mt-2" />
          <div class="row">
            <div class="col-md-1"></div>
            <h6 class="col-md-4">Bank Details</h6>
          </div>

          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-5">
              <label for="">Name As Per Bank : </label>
              <input
                type="text"
                [(ngModel)]="nameAsPerBank"
                class="form-control"
              />
            </div>
            <div class="col-md-5">
              <label for="">Account Number : </label>
              <input
                type="text"
                [(ngModel)]="bankAccountNumber"
                class="form-control"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-5">
              <label for="">IFSC Code : </label>
              <input type="text" [(ngModel)]="ifscCode" class="form-control" />
            </div>
            <div class="col-md-5">
              <label for="">Bank Name : </label>
              <input type="text" [(ngModel)]="bankName" class="form-control" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-5">
              <label for="">Upi Mobile No : </label>
              <input
                type="text"
                [(ngModel)]="upiMobileNumber"
                class="form-control"
              />
            </div>
            <div class="col-md-5">
              <label for="">Upi ID : </label>
              <input type="text" [(ngModel)]="upiID" class="form-control" />
            </div>
          </div>

          <div class="row">
            <div class="col-md-1"></div>

            <div class="col-md-5">
              <label for="">Payment App : </label>
              <input
                type="text"
                [(ngModel)]="paymentApp"
                class="form-control"
              />
            </div>
          </div>

          <div class="row mt-2 mb-2 text-center">
            <div class="col-md-12">
              <button
                (click)="updateDriver()"
                class="btn btn-primary btn-lg btn-block"
              >
                Update Driver
              </button>
            </div>
          </div>

          <div class="col-md-1"></div>
        </div>
      </div>
  </ng-template>
  </div>

  <!-- view Details model -->
  <div class="card-body modal-lg">
    <ng-template #content1 let-c="close" let-d="dismiss">
      <div class="modal-header">
        <h4 class="modal-title"><i class="fa fa-eye"></i> View Details</h4>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="d('Cross click')"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row mt-1 mb-1 d-flex flex-column align-items-center">
          <div class="col-md-4"></div>
          <div class="col-md-4 mt-2 mb-2">
            <label for="">Status : </label>
            <select class="form-control" [(ngModel)]="status">
              <option value="">Select Status</option>
              <option value="0">Pending</option>
              <option value="1">In process</option>
              <option value="2">Approve</option>
              <option value="3">Reject</option>
            </select>
          </div>

          <div [hidden]="status !== '0'" class="col-md-4 mt-2 mb-2">
            <label for="">Pending Reason : </label>
            <select class="form-control" [(ngModel)]="pendingReason">
              <option value="">Select Pending Reason</option>
              <option value="Aadhar Card">Aadhar Card</option>
              <option value="Driving Licence">Driving Licence</option>
              <option value="Rc Document">Rc Document</option>
              <option value="Vehical Photos">Vehical Photos</option>
              <option value="Bank Details">Bank Details</option>
              <option value="Other">Other</option>
              <option value="Not responding">Not responding</option>
            </select>
          </div>

          <div [hidden]="status !== '2'" class="col-md-4 mt-2 mb-2">
            <label>Is Banner Pasted : </label>
            <select class="form-control" [(ngModel)]="isBannerPasted">
              <option value="">Select Banner Status</option>
              <option [ngValue]="true">Yes</option>
              <option [ngValue]="false">No</option>
            </select>
          </div>

          <div [hidden]="status !== '3'" class="col-md-4 mt-2 mb-2">
            <label>Rejection Reason : </label>
            <select class="form-control" [(ngModel)]="rejectReason">
              <option value="">Select Rejection Reason</option>
              <option value="Invalid Mobile">Invalid Mobile</option>
              <option value="Spam">Spam</option>
              <option value="Not responding">Not responding</option>
              <option value="Other">Other</option>
            </select>
          </div>
          <div class="col-md-4"></div>

          <div class="col-md-1"></div>
          <div class="col-md-10 text-center">
            <button
              [disabled]="
                status === '' ||
                (status === '0' && pendingReason === '') ||
                  (status === '3' && rejectReason === '') ||
                (status === '2' &&
                  (isBannerPasted === null || isBannerPasted === ''))
              "
              (click)="updateRequest()"
              class="btn-wide mt-2 mb-2 me-2 btn btn-primary"
            >
              Update
            </button>
          </div>
          <div class="col-md-1"></div>
        </div>

        <nav>
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <button
              class="nav-link active"
              id="nav-details-tab"
              data-bs-toggle="tab"
              data-bs-target="#viewDetails"
              type="button"
              role="tab"
              aria-controls="viewDetails"
              aria-selected="true"
            >
              <i class="fa fa-info" aria-hidden="true"></i> Driver Details
            </button>
            <button
              class="nav-link"
              id="nav-uploadDoc-tab"
              data-bs-toggle="tab"
              data-bs-target="#documentsUpload"
              type="button"
              role="tab"
              aria-controls="DocumentsUpload"
              aria-selected="false"
              (click)="getDriverDocuments()"
            >
              <i class="fa fa-file-text" aria-hidden="true"></i>Upload Documents
            </button>
            <button
              class="nav-link"
              id="nav-docs-tab"
              data-bs-toggle="tab"
              data-bs-target="#documents"
              type="button"
              role="tab"
              aria-controls="Documents"
              aria-selected="false"
              (click)="getDriverDocuments()"
            >
              <i class="fa fa-file-text" aria-hidden="true"></i> Documents
            </button>
          </div>
        </nav>

        <div class="tab-content" id="nav-tabContent">
          <div
            class="tab-pane fade show active"
            id="viewDetails"
            role="tabpanel"
            aria-labelledby="viewDetails-tab"
          >
            <div class="row">
              <div class="col-md-1"></div>
              <div class="col-md-3">
                <label for="">Name : </label>
                <input
                  type="text"
                  [ngModel]="
                    viewAllData?.firstName + ' ' + viewAllData?.lastName
                  "
                  [disabled]="true"
                  class="form-control"
                />
              </div>
              <div class="col-md-3">
                <label for="">Mobile : </label>
                <input
                  type="text"
                  [ngModel]="viewAllData?.phoneNumber"
                  [disabled]="true"
                  class="form-control"
                />
              </div>
              <div class="col-md-4">
                <label for="">Vehicle Type : </label>
                <input
                  type="text"
                  [ngModel]="viewAllData?.vehicleType"
                  [disabled]="true"
                  class="form-control"
                />
              </div>
              <div class="col-md-1"></div>

              <div class="col-md-1"></div>
              <div class="col-md-3 mt-2">
                <label for="">City : </label>
                <input
                  type="text"
                  [ngModel]="viewAllData?.city"
                  [disabled]="true"
                  class="form-control"
                />
              </div>
              <div class="col-md-7 mt-2">
                <label for="">Home Stop : </label>
                <input
                  type="text"
                  [ngModel]="viewAllData?.homeStopLocation"
                  [disabled]="true"
                  class="form-control"
                />
              </div>

              <div class="col-md-1"></div>

              <div class="col-md-1"></div>

              <div class="col-md-3 mt-2">
                <label for="">Vehicle Number : </label>
                <input
                  type="text"
                  [ngModel]="viewAllData?.vehicleNumber"
                  [disabled]="true"
                  class="form-control"
                />
              </div>
              <div class="col-md-3 mt-2">
                <label for="">Email : </label>
                <input
                  type="text"
                  [ngModel]="viewAllData?.emailId"
                  [disabled]="true"
                  class="form-control"
                />
              </div>
              <div class="col-md-4 mt-2">
                <label for="">ID : </label>
                <input
                  type="text"
                  [ngModel]="viewAllData?._id"
                  [disabled]="true"
                  class="form-control"
                />
              </div>

              <div class="col-md-1"></div>

              <div class="col-md-1"></div>
              <div class="col-md-3 mt-2">
                <label for="">Status : </label>
                <input
                  type="text"
                  [ngModel]="viewAllData?.status"
                  [disabled]="true"
                  class="form-control"
                />
              </div>
              <div class="col-md-3 mt-2">
                <label for="">Verification Status : </label>
                <input
                  type="text"
                  [ngModel]="
                    viewAllData?.verificationStatus == 0
                      ? 'Pending'
                      : viewAllData?.verificationStatus == 1
                      ? 'In-Process'
                      : viewAllData?.verificationStatus == 2
                      ? 'Completed'
                      : viewAllData?.verificationStatus == 3
                      ? 'Rejected'
                      : ''
                  "
                  [disabled]="true"
                  class="form-control"
                />
              </div>
              <div class="col-md-4 mt-2">
                <label for="">Controlled By Admin : </label>
                <input
                  type="text"
                  [ngModel]="
                    viewAllData?.isControlledByAdmin == true ? 'Yes' : 'No'
                  "
                  [disabled]="true"
                  class="form-control"
                />
              </div>
              <div class="col-md-1"></div>
              <div class="col-md-1"></div>
              <div class="col-md-3 mt-2 mb-2">
                <label for="">Current balance : </label>
                <input
                  type="text"
                  [ngModel]="viewAllData?.currentBalance"
                  [disabled]="true"
                  class="form-control"
                />
              </div>
              <div class="col-md-3 mt-2">
                <label for="">Registration Date : </label>
                <input
                  type="text"
                  [ngModel]="
                    viewAllData?.createdOnTS * 1000
                      | date : 'dd MMM yyyy hh:mm a' : 'en-IN'
                  "
                  [disabled]="true"
                  class="form-control"
                />
              </div>
              <div class="col-md-4 mt-2">
                <label for="">Approved On : </label>
                <input
                  type="text"
                  [ngModel]="
                    viewAllData?.updatedOnTS * 1000
                      | date : 'dd MMM yyyy hh:mm a' : 'en-IN'
                  "
                  [disabled]="true"
                  class="form-control"
                />
              </div>
              <div class="col-md-1"></div>
              <div class="col-md-1"></div>
              <div class="col-md-3 mt-2 mb-2">
                <label for="">Banner Pasted : </label>
                <input
                  type="text"
                  [ngModel]="viewAllData?.isBannerPasted == true ? 'Yes' : 'No'"
                  [disabled]="true"
                  class="form-control"
                />
              </div>
              <hr class="m-0" />
              <div class="col-md-1"></div>
              <div class="col-md-3 mt-2">
                <label for="">Name As Per Bank : </label>
                <input
                  type="text"
                  [ngModel]="viewAllData?.nameAsPerBank"
                  [disabled]="true"
                  class="form-control"
                />
              </div>
              <div class="col-md-3 mt-2">
                <label for="">Bank Name : </label>
                <input
                  type="text"
                  [ngModel]="viewAllData?.bankName"
                  [disabled]="true"
                  class="form-control"
                />
              </div>
              <div class="col-md-4 mt-2">
                <label for="">UPI Mobile No : </label>
                <input
                  type="text"
                  [ngModel]="viewAllData?.upiMobileNumber"
                  [disabled]="true"
                  class="form-control"
                />
              </div>
              <div class="col-md-1"></div>

              <div class="col-md-1"></div>
              <div class="col-md-3 mt-2">
                <label for="">UPI ID: </label>
                <input
                  type="text"
                  [ngModel]="viewAllData?.upiID"
                  [disabled]="true"
                  class="form-control"
                />
              </div>

              <div class="col-md-3 mt-2">
                <label for="">IFSC Code: </label>
                <input
                  type="text"
                  [ngModel]="viewAllData?.ifscCode"
                  [disabled]="true"
                  class="form-control"
                />
              </div>

              <div class="col-md-4 mt-2">
                <label for="">Account Number: </label>
                <input
                  type="text"
                  [ngModel]="viewAllData?.bankAccountNumber"
                  [disabled]="true"
                  class="form-control"
                />
              </div>
              <div class="col-md-1"></div>

              <div class="col-md-1"></div>
              <div class="col-md-3 mt-2">
                <label for="">Digital Wallet: </label>
                <input
                  type="text"
                  [ngModel]="viewAllData?.paymentApp"
                  [disabled]="true"
                  class="form-control"
                />
              </div>
              <div class="col-md-1"></div>
            </div>
          </div>

          <div
            class="tab-pane fade show"
            id="documentsUpload"
            role="tabpanel"
            aria-labelledby="DocumentsUpload-tab"
          >
            <div class="row">
              <div class="col-md-2"></div>
              <h6 class="col-md-4 mt-2"></h6>
            </div>
            <div class="row mb-2">
              <div class="col-md-2"></div>

              <div class="col-md-4 align-items-center">
                <label for="">Adhar Card Front : </label>
                <div>
                  <input
                    type="file"
                    (change)="getVehicleImage($event, 'ADHAR_CARD_F')"
                    placeholder="Adhar Card Front"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <label for="">Adhar Card Back : </label>
                <div>
                  <input
                    type="file"
                    (change)="getVehicleImage($event, 'ADHAR_CARD_B')"
                    placeholder="Adhar Card Back"
                  />
                </div>
              </div>
              <div class="col-md-2"></div>
            </div>
            <div class="row mb-2">
              <div class="col-md-2"></div>
              <div class="col-md-4">
                <label for="">RC Image : </label>
                <div>
                  <input
                    type="file"
                    (change)="getVehicleImage($event, 'RC_IMAGE')"
                    placeholder="RC Image"
                  />
                </div>
              </div>

              <div class="col-md-4">
                <label for="">Insurance Image : </label>
                <div>
                  <input
                    type="file"
                    (change)="getVehicleImage($event, 'INSURANCE_IMAGE')"
                    placeholder="Insurance Image"
                  />
                </div>
              </div>

              <div class="col-md-2"></div>
            </div>
            <div class="row mb-2">
              <div class="col-md-2"></div>
              <div class="col-md-4">
                <label for="">Driving License: </label>
                <div>
                  <input
                    type="file"
                    (change)="getVehicleImage($event, 'DRIVING_LICENSE')"
                    placeholder="Driving License"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <label for="">Driver Selfie: </label>
                <div>
                  <input
                    type="file"
                    (change)="getVehicleImage($event, 'VEHICLE_IMAGE')"
                    placeholder="Vehicle Image"
                  />
                </div>
              </div>

              <div class="col-md-2"></div>
            </div>
            <div class="row mb-2">
              <div class="col-md-2"></div>

              <div class="col-md-4">
                <label for="">Vehicle Front Image: </label>
                <div>
                  <input
                    type="file"
                    (change)="getVehicleImage($event, 'VEHICLE_F')"
                    placeholder="Vehicle Front Image"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <label for="">Vehicle Back Image : </label>
                <div>
                  <input
                    type="file"
                    (change)="getVehicleImage($event, 'VEHICLE_B')"
                    placeholder="Vehicle Back Image"
                  />
                </div>
              </div>
              <div class="col-md-2"></div>
            </div>

            <div class="row mb-2">
              <div class="col-md-2"></div>
              <div class="col-md-4">
                <label for="">Vehicle Right Image : </label>
                <div>
                  <input
                    type="file"
                    (change)="getVehicleImage($event, 'VEHICLE_R')"
                    placeholder="Vehicle Right Image"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <label for="">Vehicle Left Image: </label>
                <div>
                  <input
                    type="file"
                    (change)="getVehicleImage($event, 'VEHICLE_L')"
                    placeholder="Vehicle Left Image"
                  />
                </div>
              </div>
              <div class="col-md-2"></div>
            </div>
          </div>

          <div
            class="tab-pane fade show"
            id="documents"
            role="tabpanel"
            aria-labelledby="documents-tab"
          >
            <div class="row">
              <div class="col-md-1"></div>
              <div class="col-md-10">
                <div class="row">
                  <div
                    class="col-md-6 mt-4 mb-4"
                    *ngFor="let data of driverDocumentsData"
                  >
                    <label
                      for=""
                      class="mt-2 mb-2 font-size-xlg font-weight-B"
                      >{{ data.documentType }}</label
                    >
                    <img
                      src="{{ data.file }}"
                      alt=""
                      width="100%"
                      height="auto"
                    />
                  </div>
                  <div
                    *ngIf="driverDocumentsData.length == 0"
                    class="text-center text-danger mt-4 mb-4"
                  >
                    <span>Data Not found </span>
                  </div>
                  <!-- <div class="col-md-6">5</div> -->
                  <!-- <div class="col-md-6">5</div> -->
                  <!-- <div class="col-md-6">5</div> -->
                </div>
              </div>
              <div class="col-md-1"></div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>

  <!-- change status model -->
  <div class="card-body modal-lg">
    <ng-template #content2 let-c="close" let-d="dismiss">
      <div class="modal-header">
        <h4 class="modal-title"><i class="fa fa-edit"></i> Change Status</h4>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="d('Cross click')"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row mt-1 mb-1 d-flex flex-column align-items-center">
          <div class="col-md-4"></div>
          <div class="col-md-8 mt-2 mb-2">
            <label for="">Status : </label>
            <select class="form-control" [(ngModel)]="status">
              <option value="">Select Status</option>
              <option value="0">Pending</option>
              <option value="1">In process</option>
              <option value="2">Approve</option>
              <option value="3">Reject</option>
            </select>
          </div>

          <div [hidden]="status !== '0'" class="col-md-8 mt-2 mb-2">
            <label for="">Pending Reason : </label>
            <select class="form-control" [(ngModel)]="pendingReason">
              <option value="">Select Pending Reason</option>
              <option value="Aadhar Card">Aadhar Card</option>
              <option value="Driving Licence">Driving Licence</option>
              <option value="Rc Document">Rc Document</option>
              <option value="Vehical Photos">Vehical Photos</option>
              <option value="Bank Details">Bank Details</option>
              <option value="Other">Other</option>
              <option value="Not responding">Not responding</option>
            </select>
          </div>

          <div [hidden]="status !== '2'" class="col-md-8 mt-2 mb-2">
            <label>Is Banner Pasted : </label>
            <select class="form-control" [(ngModel)]="isBannerPasted">
              <option value="">Select Banner Status</option>
              <option [ngValue]="true">Yes</option>
              <option [ngValue]="false">No</option>
            </select>
          </div>

          <div [hidden]="status !== '3'" class="col-md-8 mt-2 mb-2">
            <label>Rejection Reason : </label>
            <select class="form-control" [(ngModel)]="rejectReason">
              <option value="">Select Rejection Reason</option>
              <option value="Invalid Mobile">Invalid Mobile</option>
              <option value="Spam">Spam</option>
              <option value="Not responding">Not responding</option>
              <option value="Other">Other</option>
            </select>
          </div>
          <div class="col-md-4"></div>

          <div class="col-md-1"></div>
          <div class="col-md-10 text-center">
            <button
              [disabled]="
                status === '' ||
                (status === '0' && pendingReason === '') ||
                  (status === '3' && rejectReason === '') ||
                (status === '2' &&
                  (isBannerPasted === null || isBannerPasted === ''))
              "
              (click)="updateRequest()"
              class="btn-wide mt-2 mb-2 me-2 btn btn-primary"
            >
              Update
            </button>
          </div>
          <div class="col-md-1"></div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
